import { Enumify } from 'enumify';

class TabulatorMutator extends Enumify {
  static TRIM = new TabulatorMutator();
  static MONEY = new TabulatorMutator();
  static _ = this.closeEnum();

  lowerEnumKey() {
    return this.enumKey.toLowerCase();
  }
}

export default TabulatorMutator;
